import {ConfirmationModal as Modal} from "../../../../../../../elements/v2/modals";
import React from "react";
import {useStore} from "../../../../../../../hooks";
import {observer} from "mobx-react";

export const ConfirmPublishModal = observer(() => {
  const { marketingStore } = useStore();
  const { modal } = marketingStore;
  
  return (
    <Modal
      isOpen={modal.confirmationPublish}
      title={"Ready to Publish Your Campaign?"}
      message={"Once published, your campaign will go live and cannot be edited."}
      isExtended={true}
      onConfirm={() => modal.onConfirm("confirmationPublish")}
      onClose={() => modal.onCancel("confirmationPublish")}
      onCancel={() => modal.onCancel("confirmationPublish")}
      onConfirmLabel="Publish"
      cancelLabel="Review"
    />
  );
});
